module.exports = __webpack_public_path__ + "02_long_black.2147b0be.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/02_long_black.png
// module id = ZsTJ
// module chunks = 0